import React, { useState, useMemo, useContext } from 'react';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';
import useDetailFetch from '../../../../hooks/useDetailFetch';

const SingleReportFilterDetails = () => {
  const { filterId } = useParams();
  const navigate = useNavigate();
  const { showToast } = useContext(ToastContext);

  const decodedId = filterId ? atob(filterId) : filterId;
  const id = decodedId.replace(/\D/g, '');
  const [showDelete, setShowDelete] = useState(false);

  const url = id ? `${API_DOMAIN}${API_ROUTES['reportFilter']}${id}/` : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'updated_at', 'created_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['reportFilter'] + id + '/', { headers });
      showToast('Report Filter deleted successfully', 'success');
      navigate('/reporting/filter/list');
    } catch (error) {
      console.error('Error deleting Report Filter:', error);
      showToast('Error deleting Report Filter', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        loading={loading}
        entityName="Report Filter"
        listPath="/reporting/filter/list"
        editPath={`/reporting/filter/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
      />
      <ConfirmModal
        show={showDelete}
        title="Delete Report Filter"
        message="Are you sure you want to delete this report filter?"
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SingleReportFilterDetails;
